"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "~/shadcn/ui/button";
export function ModeToggle() {
  const $ = _c(8);
  const {
    setTheme,
    theme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => setTheme(theme === "dark" ? "light" : "dark");
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />;
    t2 = <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 dark:text-white" />;
    t3 = <span className="sr-only">Toggle theme</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t0) {
    t4 = <Button onClick={t0} variant="outline" size="icon" className="rounded-full">{t1}{t2}{t3}</Button>;
    $[6] = t0;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}